var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid", attrs: { id: "dashboard-page" } },
    [
      _c("div", { staticClass: "col-md-12" }, [
        _c("h1", [_vm._v(_vm._s(_vm.greeting))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xl-10 col-lg-12" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-3 col-sm-6 dash-card" }, [
            _c("h2", [_vm._v("Search Auctions")]),
            _vm._v(" "),
            _c("div", [
              _c("strong", [_vm._v(_vm._s(_vm.listingCount))]),
              _vm._v(" listings today\n                ")
            ]),
            _vm._v(" "),
            _c(
              "a",
              { staticClass: "btn btn-primary", attrs: { href: "/auctions" } },
              [_vm._v("\n                    Search\n                ")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3 col-sm-6 dash-card" }, [
            _c("h2", [_vm._v("Recommended List")]),
            _vm._v(" "),
            _c("div", [
              _c("strong", [_vm._v(_vm._s(_vm.recommendCount))]),
              _vm._v(
                "\n                     cars selected for you\n                    "
              ),
              _c("br"),
              _c("br")
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-primary",
                attrs: { href: "/recommended" }
              },
              [_vm._v("\n                    View\n                ")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3 col-sm-6 dash-card" }, [
            _c("h2", [_vm._v("Review your bids")]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("strong", [_vm._v(_vm._s(_vm.bidCount))]),
                _vm._v(" "),
                _vm.bidCount === 1 ? [_vm._v("bid")] : [_vm._v("bids")],
                _vm._v("\n                    placed today"),
                _c("br"),
                _c("br")
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "a",
              { staticClass: "btn btn-primary", attrs: { href: "/user-bid" } },
              [_vm._v("\n                    View\n                ")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3 col-sm-6 dash-card" }, [
            _c("h2", [_vm._v("Request a car")]),
            _vm._v(" "),
            _vm.loggedInUser && _vm.loggedInUser.sales_rep
              ? _c(
                  "div",
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.loggedInUser.sales_rep.name) +
                        "\n                    "
                    ),
                    _vm.loggedInUser.sales_rep.profile &&
                    _vm.loggedInUser.sales_rep.profile.mobile
                      ? [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.loggedInUser.sales_rep.profile.mobile
                              ) +
                              "\n                    "
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _vm.loggedInUser.sales_rep.email
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: "mailto:" + _vm.loggedInUser.sales_rep.email
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.loggedInUser.sales_rep.email) +
                                "\n                    "
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-primary",
                attrs: { href: "/request-vehicle" }
              },
              [_vm._v("\n                    Request\n                ")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("div", { staticClass: "container full-width" }, [
            _c(
              "div",
              { staticClass: "container-table" },
              [
                _c(
                  "b-form-checkbox",
                  {
                    staticClass: "hide_prices",
                    attrs: { value: 1 },
                    model: {
                      value: _vm.hidePrices,
                      callback: function($$v) {
                        _vm.hidePrices = $$v
                      },
                      expression: "hidePrices"
                    }
                  },
                  [
                    _vm._v(
                      "\n                    Hide Prices\n                "
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("publicStock", {
            attrs: { disableHead: true, "hide-prices": _vm.hide_stock_prices }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04501968", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04501968","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/DashboardPage.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-04501968","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/DashboardPage.vue
// module chunks = 0